import Dexie from 'dexie';

if (navigator.storage && navigator.storage.persist)
    navigator.storage.persist().then(function (persistent) {
        if (persistent)
            console.warn("Storage will not be cleared except by explicit user action");
        else
            console.warn("Storage may be cleared by the UA under storage pressure.");
    });

const db = new Dexie('Extranet');

// => Site monitoring
db.version(1).stores({
    HiddenHomeWidgets: '[moduleCode+userId], userId',
    News: '[notif_date+notif_title], notif_date',
    SearchHistory: '++id, type, searchInput, [type+searchInput]',
    User: 'email',
});

db.on("ready", function callback() { }, false);
db.open()

window.addEventListener('unhandledrejection', (e) => {
    console.error("Une erreur s'est produite pendant l'exécution d'une requête", e);
});

export default db;
